import { AppBar, Drawer, List, Toolbar, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import MenuIcon from "@mui/icons-material/Menu";
import styles from "./styles.module.css";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IAuthContext } from "../../types/auth";
import { useNavigate } from "react-router-dom";
import NavButton from "./NavButton";
import NavItem from "./NavItem";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";

const NAV_ITEMS = [
  {
    href: "/app/core-products",
    title: "Catálogo de Produtos",
    featureFlag: "CORE_PRODUCTS" as const,
  },
  {
    href: "/app/core-product-categories",
    title: "Categorias de Produtos",
    featureFlag: "CORE_PRODUCTS" as const,
  },
  {
    href: "/app/orders",
    title: "Pedidos",
  },
  {
    href: "/app/seeder-orders",
    title: "Criar pedidos (PU)",
  },
  {
    href: "/app/credit-transactions",
    title: "Crédito Pré-Pago",
  },
  {
    href: "/app/finance/platform-usage-fees",
    title: "Taxas Multifeiras",
  },
  {
    href: "/app/farmer-orders",
    title: "Encomendas",
  },
  {
    href: "/app/delivery-route",
    title: "Rota de entregas",
  },
  {
    href: "/app/report",
    title: "Relatório da semana",
  },
  {
    href: "/app/profile",
    title: "Perfil",
  },
  {
    href: "/app/fair",
    title: "Feira atual",
  },
  {
    href: "/app/fair-offerings",
    title: "Produtos da Feira",
  },
  {
    href: "/app/farmers",
    title: "Agricultoras",
  },
];

const NavigationBar = () => {
  const { clearAuthTokens, tokens } = useContext(AuthContext) as IAuthContext;
  const navigate = useNavigate();
  const { flags } = useFeatureFlags();

  const [open, setOpen] = useState(false);
  const isLoggedIn = tokens.access !== null && tokens.refresh !== null;

  // Filtrar itens de navegação com base nas feature flags
  const visibleNavItems = NAV_ITEMS.filter((item) => {
    if (item.featureFlag) {
      return flags[item.featureFlag];
    }
    return true;
  });

  const handleLogout = () => {
    clearAuthTokens();
    navigate("/", { replace: true });
  };

  const toggle = () => {
    setOpen(!open);
  };

  const goToLogin = () => {
    navigate("/login");
  };

  return (
    <div className={styles.hideOnPrint}>
      <AppBar position="static">
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {isLoggedIn ? (
            <NavButton edge="start" onClick={toggle}>
              <MenuIcon />
            </NavButton>
          ) : (
            <div style={{ width: 48 }} />
          )}
          <div className={styles.title}>
            <div className={styles.logo_container}>
              <img alt="logo" className={styles.logo} src="/logo.png" />
            </div>
            <Typography>Portal da semeadora</Typography>
          </div>
          {isLoggedIn ? (
            <NavButton edge="end" onClick={handleLogout}>
              <LogoutIcon />
            </NavButton>
          ) : (
            <NavButton edge="end" onClick={goToLogin}>
              <LoginIcon />
            </NavButton>
          )}
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={open} onClose={toggle}>
        <List>
          {visibleNavItems.map((item) => (
            <NavItem key={item.href} href={item.href}>
              {item.title}
            </NavItem>
          ))}
        </List>
      </Drawer>
    </div>
  );
};

export default NavigationBar;
